import FormItem from "antd/es/form/FormItem";
import SearInputModal from "../../../SearchModal" //"../../../Composants/SearchModal";
import SearInputG from "../../../SearchInput" //"../../../Composants/SearchInput";
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import InputForm from "../../../InputT";
import { Box } from "@mui/material";
import { Spin } from "antd";
import { useState } from "react";
import DataType from "../../../../Functions/Traitement/DataPeriodAuto";
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json'

// DECLARATION DES COLONNES DU TABLEAU
const columns: ColumnsType<DataType> = [
    {
        title: 'N° CREDIT',
        dataIndex: 'NUMCRD',

    },
    {
        title: 'ID CLIENT',
        dataIndex: 'NUMCLI',
    },
    {
        title: 'NOM CLIENT',
        dataIndex: 'NOMCLI',
    },
    {
        title: 'NOM SERVICE',
        dataIndex: 'SERVGE',
    },
    {
        title: 'Nat CREDIT',
        dataIndex: 'NATCRD',
    },
    {
        title: 'MONTANT',
        dataIndex: 'MNTAUT',
    },
    {
        title: 'DATE EFFET',
        dataIndex: 'DATEFF',
    },
    {
        title: 'DATE LIMITE',
        dataIndex: 'DATEFIN',
    }
];

let searchAgence: ParamsPicklist = { CodeAgence: '', Table: "AUTORISATION", Colonne1: "NUMCRD", Colonne2: "NUMCLI", Colagence: '101', Choix: 22 }


const TabHisto = (props: { form: any, setSearchGlobal?: boolean }) => {

    // Handle pour la selection des element dans le tableau
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [donnees, setData] = useState<DataType[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed: ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    // function pour recuperer les données du local storage
    function loadData() {
        try {
            let data = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.FirstValueAuto) + '') + "")
            //alert(JSON.stringify(data))
            setData(data)
            console.log(data)
        } catch (error) {
            console.log(error)
        }
    }

    //function pour lire loadData

    setTimeout(() => {
        if (donnees.length == 0) {
            loadData()
        }
        try {
            let reset = localStorage.getItem(Data.LocalVariable.reset)
            if (reset == "1") {
                setData([])
                //localStorage.clear()
            }
        }
        catch (error) {
            console.log(error)
        }
    }, 1);
    localStorage.clear()

    return (
        <div className='tabItem'>
            <Box display={'flex'} fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                <Box fontStyle="inherit" className='border-left '>
                    <legend> Listes des autorisations cloturer </legend>
                    
                    <Box style={{ paddingLeft: 200, paddingRight:200 }}>
                        <SearInputModal disabled={false} notRequired Titre=" Recherche" label={' AGENCE'} name="numcli" Taille1={150} Taille2={369} Parametre={searchAgence} form={props.form} />
                        <Box style={{ display: 'flex'}}>
                            <Box style={{ marginRight: 10 }}  >
                                <InputForm disabled={false} notRequired label="DEBUT PERIODE" name="DATEFF" type="date" taille={160} />
                            </Box>
                            <Box style={{}}  >
                                <InputForm disabled={false} notRequired label="FIN PERIODE" name="DATLIMIT" type="date" taille={160} />
                            </Box>
                        </Box>
                        <SearInputModal disabled={false} notRequired Titre=" Recherche" label={' TYPE PRÊT'} name="numcli" Taille1={150} Taille2={350} Parametre={searchAgence} form={props.form} />
                    </Box>

                    <Box style={{ display: 'flex', marginTop: 15 }} display={"-ms-grid"} fontStyle="inherit" >
                        <Spin spinning={loading}>
                            <Table  dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio" ,getCheckboxProps:(reccord)=>({disabled: false})}} style={{ width: '85%' }} columns={columns} scroll={{ y: 8000, x: 20 }} pagination={false} />
                        </Spin>
                    </Box>

                </Box>
            </Box>

        </div>
    );

}

export default TabHisto;